import React from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import { CardView } from 'design-system';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import IconEmptyState from 'design-system/icons/IconEmptyState';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isWeb } from '../../../../constants';
const strings = {
    title: 'No results found',
    subtitle: 'We have not found the learning material you were looking for',
};
const NoLearnContent = () => {
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    return (<View style={paddingHorizontalStyle}>
      <CardView withPadding>
        <View style={styles.container}>
          <IconEmptyState round/>
          <Spacer h={8}/>
          <Text Text-16 centered>
            {strings.title}
          </Text>
          <Spacer h={8}/>
          <Text TextThin-14 centered Gray>
            {strings.subtitle}
          </Text>
        </View>
      </CardView>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        paddingVertical: rem(24),
        paddingHorizontal: rem(24),
    },
});
export default NoLearnContent;
